jQuery(document).ready(function ($) {
	$( '.taxonomyList' ).on('change', function(e) {
			e.preventDefault()

			if ($( this ).hasClass( 'taxonomyList--blog' )) {
				var query = [],
				base_url = window.location.pathname,
				load_url = base_url,
				topic = $( '.taxonomyList-select' ).val(),
				search = encodeURIComponent( $( '.postSearch' ).val() );

				if ( topic !== "" ) {
					query.push( "topic=" + topic );
				}

				if ( search !== "" ) {
					query.push( "search=" + search );
				}

				query = query.join( "&", query );

				if ( query.length ) {
					load_url = load_url + "?" + query;
				}

				$( '#ajax-featuredPost' ).load(
					base_url + '?topic=' + topic + '&search=' + search + ' #ajax-featuredPost>*'
				);
				$( '#ajax-posts' ).load(
					base_url + '?topic=' + topic + '&search=' + search + ' #ajax-posts>*'
				);
				$( '#pagination' ).load(
					base_url + '?topic=' + topic + '&search=' + search + ' #pagination>*'
				);

				history.pushState( {'topic': topic}, "Results", load_url );
			} else if ($( this ).hasClass( 'taxonomyList--resources' )) {
				var query = [],
				base_url = window.location.pathname,
				load_url = base_url,
				type = $( '.taxonomyList-select' ).val(),
				search = encodeURIComponent( $( '.postSearch' ).val() );

				if ( type !== "" ) {
					query.push( "type=" + type );
				}

				if ( search !== "" ) {
					query.push( "search=" + search );
				}

				query = query.join( "&", query );

				if ( query.length ) {
					load_url = load_url + "?" + query;
				}

				$( '#ajax-featuredPost' ).load(
					base_url + '?type=' + type + '&search=' + search + ' #ajax-featuredPost>*'
				);
				$( '#ajax-posts' ).load(
					base_url + '?type=' + type + '&search=' + search + ' #ajax-posts>*'
				);
				$( '#pagination' ).load(
					base_url + '?type=' + type + '&search=' + search + ' #pagination>*'
				);

				history.pushState( {'type': type}, "Results", load_url );
			}
		});

	$( '.taxonomyList-taxonomy' ).click(
		function(e) {
			e.preventDefault()
			$( '.taxonomyList-taxonomy' ).removeClass( 'active' )
			$( this ).addClass( 'active' )

			$( '.taxonomyList' ).trigger( 'change' )
		}
	);

	$( '.taxonomyList-select' ).on(
		'change',
		function() {
			$( '.taxonomyList' ).trigger( 'change' )
		}
	);

	$( '.postItem-taxonomy' ).click(
		function(e) {
			e.preventDefault()
			window.location.href = $( this ).attr( 'href' )
		}
	);

	$( ".postSearch" ).keypress(
		function(event) {
			if (event.which == 13) {
				event.preventDefault();
				$( '.taxonomyList' ).trigger( 'change' )
			}
		}
	);

	$( '#pagination' ).on(
		'click',
		'a',
		function(e){
			e.preventDefault();
			$( this ).remove();

			var load_url = $( this ).attr( 'href' )

      if ($('.taxonomyList--blog').length) {
        var query = [],
        topic = $('.taxonomyList-select').val(),
        search = encodeURIComponent($('.postSearch').val());

        if( topic !== "" ){
          query.push( "topic=" + topic );
        }

        if( search !== "" ){
          query.push( "search=" + search );
        }

        query = query.join("&", query);

        if( query.length ){
          load_url = load_url + "&" + query;
        }
      }

			if ($( '.taxonomyList--resources' ).length) {
				var query = [],
				base_url = window.location.pathname,
				type = $( '.taxonomyList-select' ).val(),
				search = encodeURIComponent( $( '.postSearch' ).val() );

				if ( type !== "" ) {
					query.push( "type=" + type );
				}

				if ( search !== "" ) {
					query.push( "search=" + search );
				}

				query = query.join( "&", query );

				if ( query.length ) {
					load_url = load_url + "&" + query;
				}
			}

			$( '#ajax-loader' ).load(
				load_url + ' #ajax-posts>*',
				function(){
					$( '#ajax-posts' ).append( $( '#ajax-loader' ).html() );
				}
			);
			$( '#pagination' ).load(
				load_url + ' #pagination>*',
				function() {
					console.log( 'done' )
				}
			);
		}
	);

	function getUrlParameter(sParam) {
		var sPageURL = decodeURIComponent( window.location.search.substring( 1 ) ),
		  sURLVariables = sPageURL.split( '&' ),
		  sParameterName,
		  i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split( '=' );

			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
	}

	function pageLoad() {
		if (getUrlParameter( 'topic' ) !== undefined) {
			$( '.taxonomyList-select--topic' ).val( getUrlParameter( 'topic' ) )
		}

		if (getUrlParameter( 'type' ) !== undefined) {
			$( '.taxonomyList-select--type' ).val( getUrlParameter( 'type' ) )
		}

		if (getUrlParameter( 'search' ) !== undefined) {
			$( '.postSearch' ).val( getUrlParameter( 'search' ) )
		}
	}
	pageLoad()
});
